import type { BillingTranslations } from "../../types/billing";

export const billing: BillingTranslations = {
  plans: {
    storageRequested: "{requested} vajalik; {available} saadaval.",
    legacyAgreement:
      "See kokkulepitud hind kehtib organisatsiooni senise hinnastusega hoonetele. Oma paketiga hoonetele kehtib valitud paketi hind.",
    currentLegacyRate:
      "Hoone senine kokkulepitud hind: {amount} kuus. Kinnita pakett, et minna selle hoone puhul üle paketipõhisele arveldamisele.",
    summary: {
      included: "PAKETT SISALDAB",
      chatQuestions: "Vestlusküsimused / kuu",
      currentRate: "Praegune hind:",
      perBuildingMonth: "/ hoone / kuu",
      perMonth: "/ kuu",
      excludingVat: "käibemaksuta",
      monthlyTotal: "Lisandub teie kuusummale",
    },
    activationPending:
      "Hoone aktiveerimine ootab arvelduse kinnitust. Projektid, vestlusküsimused, PM-ülesanded ja üleslaadimised pole enne kinnitamist saadaval. Kui makse vajab lisakinnitust, lõpeta see jaotises Arveldus → Arved ning proovi seejärel aktiveerimist uuesti.",
    retryActivation: "Proovi aktiveerimist uuesti",
    activated: "Hoone on aktiveeritud.",
    names: { free: "Free", starter: "Starter", growing: "Growing", scale: "Scale" },
    plan: "Pakett",
    monthlyPrice: "{amount}/kuus",
    limitsInfo: "Paketi piirangud",
    storage: "Hoone salvestusruum",
    projects: "Arhiveerimata projektid",
    chatQuestions: "Vestlusküsimused kalendrikuus",
    pmIssues: "PM-ülesanded",
    unlimited: "Piiramatu",
    allowance: "{count}",
    usage: "{used} / {count}",
    freeLimit: "Üks tasuta hoone ühe organisatsiooni kohta. Arhiveerimine kohta ei vabasta.",
    noCard: "Free-pakett ei vaja maksekaarti ega arveldusandmeid.",
    change: "Muuda paketti",
    confirm: "Kinnita pakett",
    changed: "Hoone pakett on muudetud.",
    changeFailed: "Hoone paketti ei õnnestunud muuta.",
    changeTiming:
      "Piirangud muutuvad pärast paketi kinnitamist. Uus kuuhind kehtib järgmisest uuendamisest; selle kuu eest lisatasu ega tagasimakset ei tehta.",
    pending: "Vahetamisel paketile {plan}",
    pendingHelp: "Paketi muutmine ootab kinnitust. Kuni kinnitamiseni kuvatakse praegune pakett.",
    unavailable: "Hoone pakette ei õnnestunud laadida.",
    ownerCreation: "Palu organisatsiooni omanikul valida pakett ja lisada hoone arvelduse lehel.",
    freeBuildingLimit:
      "Sellel organisatsioonil on Free-paketi hoone juba olemas. Muuda selle hoone pakett tasuliseks või vali uuele hoonele tasuline pakett.",
    freeAccountLimit:
      "Sinu kontol on Free-paketi hoone juba olemas. Muuda selle pakett enne uue Free-paketi hoone lisamist tasuliseks või vali tasuline pakett.",
    projectLimit:
      "Selle hoone pakett lubab {limit} arhiveerimata projekti. Arhiveeri projekt või palu organisatsiooni omanikul valida hoonele suurem pakett.",
    pmIssueLimit:
      "Selle hoone pakett lubab {limit} PM-ülesannet. Eemalda ülesanne või palu organisatsiooni omanikul valida hoonele suurem pakett.",
    chatLimit:
      "Selle hoone pakett lubab {limit} vestlusküsimust kalendrikuus. Proovi järgmisel kuul uuesti või palu organisatsiooni omanikul valida hoonele suurem pakett.",
    chatUnavailable:
      "Hoone vestlusküsimuste limiiti ei õnnestunud kontrollida. Küsimust ei saadetud. Palun proovi uuesti.",
    storageLimit:
      "Selle hoone salvestusruum on {limit}. Eemalda faile või palu organisatsiooni omanikul valida hoonele suurem pakett.",
    planLimit:
      "Hoone kasutus ületab valitud paketi piirangut. Vähenda kasutust või vali suurem pakett.",
    planStorageLimit:
      "Hoone failimaht ületab valitud paketi salvestusruumi limiidi. Eemalda faile või vali suurema salvestusruumiga pakett ja proovi uuesti.",
    planStorageAllowance:
      "Valitud pakett võimaldab {limit} salvestusruumi. Eemalda faile või vali suurema salvestusruumiga pakett ja proovi uuesti.",
    planChangeBusy:
      "Selle hoone paketimuudatus ootab juba kinnitust. Oota enne uue muudatuse tegemist kinnituse saabumist.",
  },
  nav: {
    group: "Arveldus",
    overview: "Ülevaade",
    details: "Arveldusandmed",
    invoices: "Arved",
  },
  page: {
    overviewTitle: "Ülevaade",
    overviewSubtitle: "Arved väljastatakse selle loendi alusel",
    detailsTitle: "Arveldusandmed",
    detailsSubtitle:
      "Neid andmeid kasutatakse igal arvel. Muuta saab neid ainult organisatsiooni omanik.",
    invoicesTitle: "Arved",
    pilotTitle: "Pole aktiivne",
    pilotBody:
      "See organisatsioon on piloodis, seega tasu ei võeta ja siin pole veel midagi näha. Piloodi lõppedes lepime teiega hinna kokku ning siia ilmuvad teie hooned ja arved.",
  },
  shell: {
    statusUnknownTitle: "Arveldusolek ei ole kättesaadav",
    statusUnknownBody:
      "Me ei saa praegu selle organisatsiooni arveldusolekut kontrollida, seetõttu ei saa uusi hooneid lisada. Kõik muu toimib tavapäraselt.",
    reasonReadOnly:
      "See organisatsioon on ainult loetav kuni tähtaja ületanud arve tasumiseni, seega ei ole see toiming saadaval.",
    reasonStatusUnknown:
      "See toiming ei ole saadaval, kuni organisatsiooni arveldusolekut ei õnnestu kontrollida.",
    reasonDetailsMissing: "Enne hoone lisamist lisage arveldusandmed.",
    reasonPaymentMethodMissing: "Enne hoone lisamist seadistage makseviis.",
  },
  banners: {
    pilotTitle: "Pilootkonto",
    pilotBody:
      "See organisatsioon on piloodis kuni {date}. Tasu ei võeta ja arveldusandmeid pole vaja esitada.",
    pilotBodyOpenEnded:
      "See organisatsioon on piloodis. Kuni lõppkuupäevas kokku leppimiseni tasu ei võeta ja arveldusandmeid pole vaja esitada.",
    detailsMissingTitle: "Lisage arveldusandmed",
    detailsMissingBody:
      "Enne arve koostamist vajame teie ettevõtte andmeid. Kui need on salvestatud, saate lisada esimese hoone.",
    detailsMissingAction: "Lisa andmed",
    overdueTitle: "Arve {number} on tähtaja ületanud",
    overdueBody:
      "Maksetähtaeg oli {date}. Kui see jääb 30 päevaks tasumata, muutub organisatsioon ainult loetavaks.",
    overdueBodyNoDueDate:
      "See arve on endiselt tasumata. Kui see jääb arve kuupäevast 30 päevaks tasumata, muutub organisatsioon ainult loetavaks.",
    readOnlyTitle: "See organisatsioon on ainult loetav",
    readOnlyBody:
      "Arve on olnud tasumata üle 30 päeva. Kõik jääb nähtavaks ja allalaaditavaks. Kuni arve tasumiseni ei saa te lisada hooneid, avada projekte ega laadida üles dokumente.",
    viewInvoice: "Vaata arvet",
    paymentMethodMissingTitle: "Lisage makseviis",
    paymentMethodMissingBody:
      "Valige arveldusandmete lehel kaart või SEPA ja viige seadistamine lõpuni, enne kui lisate hooneid.",
    setUpPaymentMethod: "Seadista makseviis",
    paymentFailedTitle: "Arve {number} tasumine ebaõnnestus",
    paymentFailedBody:
      "Me ei saanud {date} teie kaardilt tasu võtta. Uuendage makseviisi, vastasel juhul muutub organisatsioon 30 päeva pärast arve kuupäeva ainult loetavaks.",
    updatePaymentMethod: "Uuenda makseviisi",
  },
  rate: {
    agreedRate: "Teie kokkulepitud hind",
    agreedUntil: "Kokku lepitud kuni",
    openEnded: "Tähtajatu",
    contact: "Teie kontaktisik",
    perBuildingMonth: "/ hoone / kuus",
  },
  summary: {
    currentPeriod: "Käesolev periood",
    closesIn_one: "Lõpeb {days} päeva pärast",
    closesIn_other: "Lõpeb {days} päeva pärast",
    buildings: "Tasulised hooned",
    addedThisPeriod_one: "{count} lisatud sel perioodil",
    addedThisPeriod_other: "{count} lisatud sel perioodil",
    nextInvoiceOn: "Järgmine arve · {date}",
    renewalOn: "Igakuine makse · {date}",
    excludingVat: "käibemaksuta",
    taxPerAgreement: "Käibemaks vastavalt kehtivale kokkuleppele",
    chargedTo: "tasu võetakse: {method}",
    sentByEmail: "saadetakse e-postiga",
    sentAsEInvoice: "saadetakse e-arvena",
  },
  table: {
    sectionTitle: "Selle perioodi hooned",
    building: "Hoone",
    servicePeriod: "Teenuse periood",
    amount: "Summa",
    action: "Tegevus",
    footerTotal: "Kogusumma",
    emptyTitle: "Hooneid veel ei ole",
    emptyBody: "Vali esimese hoone lisamisel pakett. Free-pakett ei vaja maksekaarti.",
    removalScheduled: "Eemaldamine planeeritud",
    remove: "Eemalda",
    add: "Lisa hoone",
  },
  removed: {
    sectionTitle: "Eemaldatud hooned",
    building: "Hoone",
    usableUntil: "Kasutatav kuni",
    deletedOn: "Kustutamise kuupäev",
    removedOn: "Eemaldatud {date}",
    restore: "Taasta",
    restored: "Hoone taastatud.",
    restoreFailed: "Hoone taastamine ebaõnnestus.",
  },
  transfer: {
    before:
      "Kas omanik või haldaja vahetub? Hoone koos kõigi andmetega saab eemaldamise asemel üle anda teisele organisatsioonile. Kirjutage aadressil",
    after: "ja meie tiim korraldab ülejäänu.",
  },
  consent: {
    addTitle: "Lisa hoone",
    restoreTitle: "Taasta see hoone",
    description:
      "Tasu sõltub hoonete valitud pakettidest. Uute hoonete arved esitatakse kohe; igakuised kuutasud koondatakse ühele arvele.",
    quoteLead: "See lisandub teie kuusummale",
    quoteDetail:
      "{amount} ja kohaldatav käibemaks võetakse kohe ja arve esitatakse arveldusperioodi järelejäänud {days} päeva eest. Järgmisel arvelduskuupäeval uuenevad kõik hooned koos ühe makse ja arvega.",
    quoteFullMonth:
      "Täielik kuutasu {amount} ja kohaldatav käibemaks võetakse kohe ja arve esitatakse kohe. Tänasest saab organisatsiooni igakuine arvelduskuupäev. Kõik hooned uuenevad koos sellel kuupäeval.",
    quoteNextInvoice:
      "{amount} ja kohaldatav käibemaks järelejäänud {days} päeva eest lisatakse organisatsiooni järgmisele kuuarvele kuu 1. kuupäeval koos järgmise kuu tellimusega. Praegu makset ei võeta.",
    quoteTimingUnknown:
      "Tasutav summa kinnitatakse aktiveerimisel. Uue tasulise hoone eest tasutakse ja arve esitatakse kohe; kuutasud koondatakse organisatsiooni arvelduskuupäeval ühele arvele.",
    restoreSamePeriodLead: "See periood on juba tasutud",
    restoreSamePeriod: "Sel perioodil lisatasu ei ole.",
    loading: "Arvutame hinda…",
    quoteUnavailable: "Hinda ei õnnestunud laadida, seega ei ole veel midagi lisatud.",
    retry: "Proovi uuesti",
    cancel: "Tühista",
    agreeAdd: "Nõustun ja lisan hoone",
    agreeRestore: "Nõustun ja taastan hoone",
  },
  addDialog: {
    title: "Lisa hoone",
    address: "Aadress",
    addressPlaceholder: "Hoone F, Tallinn",
    cadastralCode: "Katastrikood",
    cadastralPlaceholder: "12345:678:9012",
    cadastralFormat: "Kasutage kuju 12345:678:9012.",
    cancel: "Tühista",
    submit: "Lisa hoone",
    added: "Hoone lisati sellesse arveldusperioodi.",
    addFailed: "Hoone lisamine ebaõnnestus.",
  },
  removeDialog: {
    title: "Eemalda hoone",
    activeUntil: "aktiivne kuni {date}",
    body: "Hoone jääb täielikult kasutatavaks kuni tasutud perioodi lõpuni. Alates {date} selle eest tasu ei võeta ja teie kuusumma väheneb {amount} võrra.",
    bodyWithoutAmount:
      "Hoone jääb täielikult kasutatavaks kuni tasutud perioodi lõpuni. Alates {date} selle eest tasu ei võeta.",
    afterHeading: "Pärast {date}",
    afterBody:
      "Hoonet ei saa enam kasutada ja uusi faile üles laadida ei saa. Selle dokumente saab alla laadida ning hoone saab järgmise 30 päeva jooksul taastada. {date} see kustutatakse ja seda ei saa enam taastada.",
    datesNote: "Need kuupäevad kinnitatakse teie arveldusperioodi järgi hoone eemaldamisel.",
    transferHint:
      "Kui hoone omanik või haldaja vahetub, andke see eemaldamise asemel üle nende organisatsioonile. Kõik andmed jäävad alles.",
    cancel: "Tühista",
    confirm: "Eemalda hoone",
    removed: "Hoone eemaldamine on planeeritud.",
    removeFailed: "Hoone eemaldamine ebaõnnestus.",
  },
  details: {
    draftSaveFailed:
      "Hoone andmete säilitamine ebaõnnestus. Proovige enne vormilt lahkumist uuesti.",
    returnToBuilding: "Jätka hoone lisamist",
    saveAndSetUp: "Salvesta ja seadista makseviis",
    companyName: "Ettevõtte nimi",
    optional: "Valikuline",
    registryCode: "Registrikood",
    vatNumber: "KMKR number",
    vatPlaceholder: "EE100000000",
    legalAddress: "Juriidiline aadress",
    invoiceEmail: "Arve e-post",
    invoiceEmailPlaceholder: "arved@naidis.ee",
    purchaseOrderNumber: "Ostutellimuse number",
    purchaseOrderPlaceholder: "Valikuline",
    purchaseOrderHint: "Kuvatakse igal arvel, kui teie raamatupidamine seda vajab.",
    paymentMethod: "Makseviis",
    paymentByCard: "Kaart (automaatne)",
    paymentBySepa: "SEPA otsekorraldus (automaatne)",
    paymentByEmail: "Pangaülekanne e-postiga",
    paymentByEInvoice: "Pangaülekanne e-arvega",
    recommended: "— soovitatud",
    paymentHint: "Arved koostatakse 14-päevase maksetähtajaga.",
    paymentHintAutomatic: "Iga arve tasutakse automaatselt selle koostamise päeval.",
    noPaymentMethod: "Makseviisi veel ei ole",
    saveMethodFirst: "Salvestage esmalt see makseviis ja seejärel seadistage see.",
    setUpPaymentMethod: "Seadista makseviis",
    changePaymentMethod: "Muuda",
    setupFailed: "Makseviisi seadistamist ei õnnestunud avada.",
    setupSaved: "Makseviis salvestatud.",
    setupCancelled: "Makseviisi seadistamine katkestati.",
    save: "Salvesta andmed",
    saved: "Arveldusandmed salvestatud.",
    saveFailed: "Arveldusandmete salvestamine ebaõnnestus.",
    restrictedTitle: "Arveldusandmed on ainult loetavad",
    ownerOnly: "Arveldusandmeid saab muuta ainult organisatsiooni omanik.",
    errors: {
      companyRequired: "Ettevõtte nimi on kohustuslik.",
      registryTooLong: "Registrikood võib olla kuni {max} tähemärki.",
      vatCountryFormat: "{country} KMKR-number peab olema kujul {example}.",
      vatPrefix: "Alustage KMKR-numbrit ELi riigikoodiga. Kreeka on EL ja Põhja-Iirimaa on XI.",
      addressRequired: "Juriidiline aadress on kohustuslik.",
      emailInvalid: "Sisestage kehtiv arve e-posti aadress.",
      companyTooLong: "Ettevõtte nimi tohib olla kuni {max} märki.",
      addressTooLong: "Juriidiline aadress tohib olla kuni {max} märki.",
      emailTooLong: "Arve e-posti aadress tohib olla kuni {max} märki.",
      purchaseOrderTooLong: "Ostutellimuse number tohib olla kuni {max} märki.",
    },
  },
  invoices: {
    invoice: "Arve",
    period: "Periood",
    due: "Maksetähtaeg",
    status: "Olek",
    amount: "Summa",
    pdf: "PDF",
    dueOnIssue: "Tasutakse koostamisel",
    buildingCount_one: "{count} hoone",
    buildingCount_other: "{count} hoonet",
    statusDraft: "Mustand",
    statusDue: "Tasumata",
    statusOverdue: "Tähtaeg ületatud",
    statusPaid: "Tasutud",
    statusVoid: "Tühistatud",
    statusUncollectible: "Maha kantud",
    statusPaymentFailed: "Makse ebaõnnestus",
    paidOn: "Tasutud {date}",
    download: "Laadi alla",
    downloadLabel: "Laadi alla arve {number} PDF",
    downloadUnavailable: "Arve PDF ei ole veel saadaval.",
    downloadPending: "Arve PDF-i allalaadimist valmistatakse ette.",
    downloadFailed: "Arve allalaadimine ebaõnnestus.",
    emptyTitle: "Arveid veel ei ole",
    emptyBody: "Koostatud arved ja nende PDF-id ilmuvad siia.",
  },
  restrictions: {
    addReadOnly: "Hooneid ei saa lisada, kuni organisatsioon on ainult loetav.",
    addDetailsMissing: "Enne hoone lisamist täitke nõutud arveldusandmed.",
    addPaymentMethodMissing: "Enne hoone lisamist seadistage makseviis.",
    restoreReadOnly: "Hooneid ei saa taastada, kuni organisatsioon on ainult loetav.",
    restoreDetailsMissing: "Enne hoone taastamist täitke nõutud arveldusandmed.",
    restorePaymentMethodMissing: "Enne hoone taastamist seadistage makseviis.",
    restoreExpired: "30-päevane taastamisaken on lõppenud.",
    restoring: "Seda hoonet taastatakse.",
    restorePending: "Oodake, kuni käimasolev taastamine lõpeb.",
    ownerOnly: "Arvelduslehtedelt saab hooneid muuta ainult organisatsiooni omanik.",
    noPermission: "Teil pole selleks õigust.",
  },
  guards: {
    readOnly:
      "Organisatsioon on ainult loetav, kuni tähtaja ületanud arve on tasutud, seega uut luua ei saa.",
    detailsMissing: "Salvestage enne hoone lisamist oma arveldusandmed.",
    buildingLapsed:
      "See hoone eemaldati ja kasutusaeg on läbi. Taastage see arvelduse ülevaates, et sinna uuesti lisada.",
  },
  errors: {
    contextTitle: "Arveldusandmete laadimine ebaõnnestus.",
    contextBody: "Kuni olek on teadmata, ei saa arveldust muuta.",
    overviewTitle: "Arvelduse ülevaate laadimine ebaõnnestus.",
    overviewBody: "Kuni olek on teadmata, ei saa arveldust muuta.",
    invoicesTitle: "Arvete laadimine ebaõnnestus.",
    retry: "Proovi uuesti",
    notOwner: "Seda saab teha ainult organisatsiooni omanik.",
    readOnly: "Organisatsioon on ainult loetav, kuni tähtaja ületanud arve on tasutud.",
    detailsMissing: "Salvestage esmalt oma arveldusandmed.",
    paymentMethodMissing: "Seadistage esmalt kaardi- või SEPA-makseviis.",
    pilot: "See organisatsioon on piloodis, seega arveldada pole veel midagi.",
    validation: "Osa andmeid ei ole kehtivad. Kontrollige vormi ja proovige uuesti.",
    validationDetail: "Osa andmeid ei ole kehtivad: {message}",
    stripe: "Arveldus ei ole hetkel saadaval. Proovige hetke pärast uuesti.",
    stripeDetail: "Arvelduspäring ebaõnnestus: {message}",
    generic: "Midagi läks valesti. Palun proovige uuesti.",
  },
};
